import { createState } from "../state.js";
import { startState } from "./start.state.js";

export const initialState = ({ screen, stateMachine }) =>
  createState("initial", {
    screen,
    stateMachine,
    onEnter: () => {
      const message = document.createElement("p");
      message.innerHTML = "Press the start button to begin!";
      message.classList.add("message");
      screen.append(message);

      const startButton = document.querySelector("#startButton");
      startButton.addEventListener("click", (e) => {
        e.preventDefault();
        stateMachine.transition(startState({ screen, stateMachine }));
      });
    },
    onExit: () => screen.clear(),
  });
